let timer: ReturnType<typeof setTimeout> | undefined;

/** Short status message. Errors stay longer and are styled red so they are never missed. */
export function toast(msg: string, isError = false) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.className = 'toast' + (isError ? ' err' : '');
  t.hidden = false;
  clearTimeout(timer);
  timer = setTimeout(() => { t.hidden = true; }, isError ? 5200 : 2400);
}
